<div class="grid align-center vertical-container">
  <div class="col-12">
    <div class="box">
      <div class="brand-bar"></div>
      <div class="grid align-center margin-top">
        <div class="col-lg-2 ml-2 mr-2">
          <div class="box">
            <h1>Manage Supporting Document Message</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (dataLoaded) {
  <div>
    @if (!message && !isEditMode) {
      <div class="center">
        <div>
          <img
            [src]="imagePath"
            class="float-left brand-image support-document-image"
            alt="Add Support Document Message"
          />
        </div>
      </div>
    }
    @if (!message && !isEditMode) {
      <div class="add-button center">
        <button
          pButton
          type="button"
          label="Add Message"
          title="Add Message"
          (click)="addMessage()"
          #buttonAddMessage
        ></button>
      </div>
    }
    <form #supportDocumentForm="ngForm">
      @if (message && !isEditMode) {
        <div class="document-information-container">
          <div [innerHTML]="message" #viewMessage></div>
        </div>
      }
      <div class="float-left">
        @if (displaySaveControls) {
          <div class="align-right">
            ({{ inputCharacters }}/{{ maxCharacters }}) Characters
          </div>
        }
        @if (displaySaveControls) {
          <div>
            <div class="NgxEditor__Wrapper" tabindex="0">
              <ngx-editor-menu
                [editor]="editor"
                [toolbar]="[
                  ['bold', 'italic', 'underline', 'link', 'bullet_list']
                ]"
              >
              </ngx-editor-menu>
              <ngx-editor
                [editor]="editor"
                [(ngModel)]="message"
                (ngModelChange)="textChanged($event)"
                (keypress)="keyPress($event)"
                (paste)="onPaste($event)"
                name="Message"
              ></ngx-editor>
            </div>
            <div></div>
          </div>
        }
        @if (isMaxCharactersLimitReached) {
          <label class="error-label">Maximum characters limit reached</label>
        }
        <br /><br />
        @if (message && !isEditMode) {
          <div>
            <button
              pButton
              type="button"
              label="Edit"
              title="Edit"
              class="button-custom margin-right"
              (click)="editMessage()"
              #buttonEdit
            ></button>
          </div>
        }
        @if (displaySaveControls) {
          <div class="grid flex-row-reverse button-style">
            <button
              pButton
              type="button"
              label="Save"
              title="Save"
              class="button-custom margin-right"
              (click)="saveMessage()"
              #buttonSave
            ></button>
            <button
              pButton
              type="button"
              label="Cancel"
              title="Cancel"
              class="button-custom margin-right"
              (click)="cancelMessage()"
            ></button>
          </div>
        }
      </div>
    </form>
  </div>
}
